import React from "react";
import Navbar from "../../components/Navbar";

import Productos from "../../components/ProductosNegocios";

function ProductsN() {
  return (
    <div>
      {" "}
      <div className="container">
        <Navbar />
        {/* <Filter /> */}
        <Productos />
      </div>
    </div>
  );
}

export default ProductsN;
